module.exports = __webpack_public_path__ + "img/search-in-mail.98a3e85d.png";